import React from 'react';

import type { Props } from './TitleFocusTarget.common';

export default function TitleFocusTarget({ children }: Props): React.ReactNode {
  return children;
}
